<ng-template #content>
  <ng-content />
</ng-template>

@if (state.isMobile) {
  <div class="mobile-view">
    <ng-container *ngTemplateOutlet="sidenavContent; context: { $implicit: true }" />
  </div>
  <div class="shell-container-mobile">
    <ng-container *ngTemplateOutlet="content" />
  </div>
} @else {
  <mat-sidenav-container class="shell-container h-full">
    <mat-sidenav [disableClose]="true" mode="side" [opened]="true" [style.width.px]="state.isCompact ? 84 : 240">
      <ng-container *ngTemplateOutlet="sidenavContent; context: { $implicit: false }" />
    </mat-sidenav>
    <mat-sidenav-content class="bg-neutral-0 h-full" [style.margin-left.px]="state.isCompact ? 84 : 240">
      <ng-container *ngTemplateOutlet="content" />
    </mat-sidenav-content>
  </mat-sidenav-container>
}

<ng-template #sidenavContent let-isMobile>
  <div
    class="sidenav-wrap bg-neutral-0 group h-full p-4"
    [class.is-compact]="state.isCompact"
    [class.is-mobile]="isMobile"
  >
    <div class="sidenav-inner flex h-full flex-col">
      <a
        [routerLink]="'/'"
        class="logo-link mb-6 mt-2 flex h-[48px] rounded-[0.75rem] px-4 transition-colors hover:bg-neutral-50 group-[.is-compact]:px-2"
      >
        @if (state.isCompact) {
          <img [src]="logoCompact()" [alt]="logoAlt()" class="w-[40px]" />
        } @else {
          @if (state.darkMode) {
            <img [src]="logoFullDark()" [alt]="logoAlt()" class="w-[148px]" />
          } @else {
            <img [src]="logoFull()" [alt]="logoAlt()" class="w-[148px]" />
          }
        }
      </a>

      <div class="sidenav-inner-links flex grow flex-col gap-2">
        @for (item of items(); track item.route) {
          <a
            class="sidebar-link text-secondary text-md flex items-center px-4 py-2 font-semibold group-[.is-compact]:px-2"
            [routerLink]="item.route"
            routerLinkActive="active"
          >
            <div class="aligner h-[32px] w-[32px] shrink-0">
              <img [src]="item.icon" [alt]="item.labelKey | transloco" />
            </div>
            <span class="sidebar-link-text">{{ item.labelKey | transloco }}</span>
          </a>
        }
        @if (customFooter()) {
          <ng-container *ngTemplateOutlet="customFooter()!" />
        } @else if (state.user) {
          <a
            class="sidebar-link sidebar-link-user text-secondary mt-auto flex items-center rounded-[0.75rem] px-4 py-2 font-semibold transition-colors hover:bg-neutral-50 group-[.is-compact]:px-2"
            [routerLink]="settingsRoute()"
            routerLinkActive="active"
          >
            <dojo-profile-avatar [size]="30" class="shrink-0" (clicked)="navigateToProfile()" />
            <span class="sidebar-link-text text-md truncate" [matTooltip]="state.user.fullName">{{
              state.user.fullName
            }}</span>
          </a>
        }
      </div>
    </div>
  </div>
</ng-template>
